import { Component, EventEmitter, Host, Input, Optional, Output } from '@angular/core';
import { SmsComponent } from 'src/app/pages/widget/types/sms/sms.component';
import { NotificationsService } from 'src/services/notifications.service';
import { SolicitudesService } from 'src/services/solicitudes.service';

@Component({
  selector: 'belender-cancel-request',
  templateUrl: './cancel-request.component.html',
  styleUrls: ['./cancel-request.component.scss']
})
export class CancelRequestComponent {
  @Input() data;
  @Input() customText: string = '';
  @Input() textColor: string = '';
  @Input() flowType: string = 'SMS';
  @Input() request_id: string;
  @Input() user_id: string;
  @Input() labels;
  @Output() updateStatusCode = new EventEmitter();
  requestType: 'clave-pin' | 'sms' = 'sms';
  loading: boolean = false;

  constructor(
    @Optional() @Host() private smsComponent: SmsComponent, // Acceso a métodos del padre
    private solicitudesService: SolicitudesService, 
    private notis: NotificationsService) { }

  goToCancelRequest() {
    this.loading = true;
    const data = {
      request_id: this.request_id,
      user_id: this.user_id
    }

    if (this.flowType === 'ClavePin') {
      this.requestType = 'clave-pin';
    } else {
      this.requestType = 'sms';
    }

    this.solicitudesService.cancelRequest(data, this.requestType).then((e: any) => {
      if(e && e.data) {
        if (this.flowType === 'SMS') {
          this.setSmsCancel('consent_process_canceled');
        } else {
          this.updateStatusCode.emit('consent_process_canceled'); 
        }
      }
      if(e.message) {
        this.showAlert(e.status ?  this.capitalizeFirstLetter(e.status) + '!' : 'Aviso!', e.message)
      }
      setTimeout(() => {
        this.loading = false;
      }, 1000)
    }).catch(e => {
      this.loading = false;
      this.showAlert('Error!', e.message || e)
    });
  }

  capitalizeFirstLetter(inputString) {
    if (typeof inputString !== 'string' || inputString.length === 0) {
      return inputString; 
    }
    return inputString.charAt(0).toUpperCase() + inputString.slice(1);
  } 

  showAlert(title, message) {
    this.notis.showAlert(title, message);
  }

  setSmsCancel(ev) {
    this.smsComponent.setRequestStatus(ev)
    this.smsComponent.setStatus();
  }
}
